import axios from 'axios';
import Form from './Form';
import FormLoader from './FormLoader';
import Culture from '../culture';
import DOM from '../Library/DOM';
import Locker from '../Library/Locker';
import SendButton from './SendButton';
import Toaster from './Toaster';
import ValidationConnector from './ValidationConnector';

const IS_HU = Culture.getBool();

class MultipartForm extends Form {
    constructor(form, sendButtonSelector, formLoaderSelector) {
        console.log('mutlipart form constrt');
        super(form, sendButtonSelector);
        // this.loader = new FormLoader(formLoaderSelector);
        // this.loader.form = this.form;
    }

    submit() {
        console.log('multipart form submit override');
        console.log(this.form);
        if (this.dispatchEvent(new CustomEvent('submit', { cancelable: true }))) {
            this.lock();
            this.sendButtons.forEach((x) => { x.start(); });
            // this.loader.show();
            const data = new FormData(this.form);
            axios({
                url: this.form.action,
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                data,
            }).then((response) => {
                console.log(response.data);
                if ('success' in response.data) {
                    if (this.dispatchEvent(new CustomEvent('success', { cancelable: true, detail: response.data }))) {
                        if (response.data.success !== '') Toaster.success(response.data.success);
                        this.sendButtons.forEach((x) => { x.success(); });
                        this.disable();
                    }
                } else {
                    if ('error' in response.data) {
                        if (response.data.error !== '') {
                            Toaster.error(response.data.error, Toaster.ERROR_CONFIG);
                        }
                    }
                    if ('errors' in response.data) {
                        console.log(Object.fromEntries(Object.entries(response.data.errors).map(([key, val]) => [`#${key}`, val])));
                        this.validation.showErrors(
                            Object.fromEntries(Object.entries(response.data.errors).map(([key, val]) => [`#${key}`, val])),
                        );
                    }
                    this.dispatchEvent(new CustomEvent('error', { detail: response.data }));
                    this.sendButtons.forEach((x) => { x.stop(); });
                    this.lock(false);
                }
                if ('redirect' in response.data) {
                    window.location = response.data.redirect;
                }
            }).catch((e) => {
                Toaster.error(response.data.error, Toaster.ERROR_CONFIG);
                // Toaster.error(IS_HU ? 'Hiba történt. Kérjük próbálja újra, vagy vegye fel velünk a kapcsolatot!' : 'Something went wrong. Please try again or contact us', Toaster.ERROR_CONFIG);
                this.sendButtons.forEach((x) => { x.stop(); });
                this.lock(false);
            });
        }
    }
}
export default MultipartForm;
